import { TOfferBookingAnalyticsClickType } from '../../types/microfrontends/newbuildingBrokerModals';
import { TOpeningPlace } from './NewbuildingBrokerModalsContext';

export const removeLeadingPlus = (phone: string): string => phone.replace(/^\+/, '');

export const mapPlaceToAnalyticsClickType = (place: TOpeningPlace): TOfferBookingAnalyticsClickType | undefined => {
  switch (place) {
    case 'bookingLabel':
      return 'main_button_card_jk';
    case 'bookingBanner':
      return 'under_flat_list';
    default:
      return undefined;
  }
};
